/** 관심아파트 매물시세 차트에서 사용하는 공용 축 인덱스다. */
export const MARKET_PRICE_AXIS = {
  PRICE: 0,
  SALE_COUNT: 1,
};

/** 매매·전세 가격은 한 축을 공유하고 단위가 다른 매물수만 숨김 보조축에 둔다. */
export const addMarketPriceAxes = (builder) => {
  builder.addNumericYAxis("시세", false, true);
  builder.addNumericYAxis("매물수", true, false);
};
